var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTtBrokenCube = function SvgTtBrokenCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: "inherit",
      height: "inherit"
    },
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21.5 24.875h3.375m0 0h3.375m-3.375 0V21.5m0 3.375v3.375M14 18.5h2.25a2.25 2.25 0 0 0 2.25-2.25V14a2.25 2.25 0 0 0-2.25-2.25H14A2.25 2.25 0 0 0 11.75 14v2.25A2.25 2.25 0 0 0 14 18.5m0 9.75h2.25A2.25 2.25 0 0 0 18.5 26v-2.25a2.25 2.25 0 0 0-2.25-2.25H14a2.25 2.25 0 0 0-2.25 2.25V26A2.25 2.25 0 0 0 14 28.25m9.75-9.75H26a2.25 2.25 0 0 0 2.25-2.25V14A2.25 2.25 0 0 0 26 11.75h-2.25A2.25 2.25 0 0 0 21.5 14v2.25a2.25 2.25 0 0 0 2.25 2.25"
  })));
};
export { SvgTtBrokenCube as ReactComponent };
export default __webpack_public_path__ + "3ed0403d5e2021a8074079aed8388447.svg";